import { Component, OnInit } from '@angular/core';
import { PageComponent, _, SharedFacade, ConfiguratorFacade } from '@icc/configurator/shared';

@Component({
    selector: 'icc-notifications-panel',
    templateUrl: './notifications-panel.component.html',
    styleUrls: ['./notifications-panel.component.scss'],
    standalone: false
})
export class NotificationsPanelComponent extends PageComponent implements OnInit {
  public title: string = _('CONFIGURATOR|Powiadomienia');
  public options = [];

  messages$ = this.sharedFacade.messages$;
  issues$ = this.configuratorFacade.issues$;

  constructor(private sharedFacade: SharedFacade, private configuratorFacade: ConfiguratorFacade) {
    super();
   }

  ngOnInit() {
  }

}
